module.exports = __webpack_public_path__ + "media/images/photo/plans/places/nagoya_city_municipal_archives-7688107e874ff62372f18eba7e52a8a7.png";